import React, { useState } from 'react';
import {ReactComponent as CheckedIcon}  from '../../icons/svg/check-icon.svg'
import { ICheckboxProps } from './CheckboxProps'
import clsx from 'clsx'

import './Checkbox.scss'

const Checkbox = (props: ICheckboxProps) => {
   const [isChecked, setIsChecked] = useState<boolean>(Boolean(props.isChecked))

   return (
      <div
         data-test-id={props.dataTestId}
         className={clsx('app-checkbox-wrapper', props.hasError && 'app-checkbox-has-error', props.className && props.className)} 
         onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            if(props.handleOnClick){
               props.handleOnClick(e)
               return
            }
            else {
               setIsChecked(!Boolean(isChecked))
               return
            }
         }}
      >
         <CheckedIcon className={clsx(props.isChecked ? 'app-checkbox-marked' : 'app-checkbox-unmarked')}/>
      </div>
   )
}

export default Checkbox
